'use client'

import { useState } from "react"
import Navbar from "../components/navbar"
import { motion } from "framer-motion"

const content = {
    tr: {
        titleTop: "Gyno Club",
        titleBottom: "Gizlilik Politikası",
        lastUpdate: "Son Güncelleme Tarihi: 28.01.2026",
        intro:
            "Bu Gizlilik Politikası, Gyno Expertise Sağlık Yatırımları A.Ş. (“Şirket”, “Biz”) tarafından geliştirilen Gyno Club mobil uygulaması (“Uygulama”) tarafından toplanan, saklanan ve işlenen kişisel verileriniz hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.",
        accept:
            "Uygulamamızı kullanarak, kişisel verilerinizin bu Gizlilik Politikası’nda belirtilen şekillerde işlenmesini kabul etmiş sayılırsınız.",
        sections: [
            {
                title: "1. Toplanan Veriler",
                text: `Hizmetlerimizi sunabilmek ve uygulama içi deneyiminizi kişiselleştirebilmek amacıyla aşağıdaki verileri işlemekteyiz:

• Kimlik Bilgileri: Ad, Soyad  
• İletişim Bilgileri: E-posta adresi, telefon numarası  
• Demografik Veriler: Doğum tarihi  
• Sağlık ve Fitness Verileri: Adet döngüsü takibi ve BMI hesaplama kapsamında girilen boy, kilo ve döngü tarihleri  
• Cihaz ve Kullanım Verileri: IP adresi, cihaz modeli, işletim sistemi sürümü ve uygulama içi etkileşimler`
            },
            {
                title: "2. Verilerin Kullanım Amaçları",
                text: `Toplanan kişisel veriler aşağıdaki amaçlarla kullanılmaktadır:

• Üyelik işlemlerinin yürütülmesi  
• Kişiselleştirilmiş astroloji, tarot ve sağlık hizmetlerinin sunulması  
• Sadakat programları ve avantajların sağlanması  
• Kampanya ve bilgilendirme iletişimi  
• Hizmet kalitesinin artırılması ve güvenliğin sağlanması`
            },
            {
                title: "3. Verilerin Paylaşımı",
                text: `Kişisel verileriniz pazarlama amacıyla üçüncü taraflara satılmaz.

Ancak;
• Teknik altyapı ve bildirim hizmetleri için (Firebase, AWS vb.)
• Yasal yükümlülükler kapsamında yetkili mercilere  
paylaşım yapılabilir.`
            },
            {
                title: "4. Sağlık Verilerine İlişkin Özel Bildirim",
                text: `Regl takvimi ve BMI hesaplama verileri hassas sağlık verisi niteliğindedir.

Bu veriler:
• Yalnızca uygulama fonksiyonları için kullanılır  
• Reklam amacıyla kullanılmaz  
• Üçüncü taraflarla bu amaçla paylaşılmaz`
            },
            {
                title: "5. Veri Güvenliği",
                text:
                    "Kişisel verileriniz HTTPS/TLS şifreleme başta olmak üzere endüstri standartlarına uygun güvenlik önlemleri ile korunmakta olup yetkisiz erişimi önlemek için gerekli teknik ve idari tedbirler alınmaktadır."
            },
            {
                title: "6. Kullanıcı Hakları ve Hesap Silme",
                text: `Hesabınızı ve kişisel verilerinizi silme hakkına sahipsiniz.

“Hesap Silme Talebi” konulu e-postanızı destek@gynoclub.com.tr adresine gönderebilirsiniz.

Yasal saklama zorunluluğu bulunan veriler hariç olmak üzere tüm verileriniz en geç 30 gün içinde silinir.`
            },
            {
                title: "7. İletişim",
                text: `Unvan: Gyno Expertise Sağlık Yatırımları A.Ş.

Adres:
Ataköy 7-8-9-10. Kısım Mah. Çobançeşme E-5 Yan Yol Cad.
A-B Blok No: 18/1 İç Kapı No: 131
Bakırköy / İstanbul

E-posta:
destek@gynoclub.com.tr
info@gynoclub.com.tr`
            }
        ]
    },
    en: {
        titleTop: "Gyno Club",
        titleBottom: "Privacy Policy",
        lastUpdate: "Last Updated: January 28, 2026",
        intro:
            "This Privacy Policy has been prepared to inform you about the personal data collected, stored, and processed by the Gyno Club mobile application developed by Gyno Expertise Health Investments Inc. (“Company”, “We”).",
        accept:
            "By using our application, you are deemed to have accepted the processing of your personal data as described in this Privacy Policy.",
        sections: [
            {
                title: "1. Data Collected",
                text: `To provide our services and personalize your experience, we process the following data:

• Identity Information: Name, surname  
• Contact Information: Email address, phone number  
• Demographic Data: Date of birth  
• Health & Fitness Data: Menstrual cycle tracking and BMI-related height, weight, and cycle dates  
• Device & Usage Data: IP address, device model, OS version, in-app interactions`
            },
            {
                title: "2. Purposes of Data Processing",
                text: `Your personal data is processed for the following purposes:

• Account creation and management  
• Personalized astrology, tarot, and health services  
• Loyalty programs and exclusive benefits  
• Campaign and notification communications  
• Service improvement and security`
            },
            {
                title: "3. Data Sharing",
                text: `Your personal data is not sold for marketing purposes.

It may be shared only with:
• Trusted infrastructure providers (Firebase, AWS, etc.)
• Authorized authorities where legally required`
            },
            {
                title: "4. Special Notice on Health Data",
                text: `Menstrual tracking and BMI data are considered sensitive health data.

Such data:
• Is used solely for app functionality  
• Is not used for advertising  
• Is not shared with third parties for these purposes`
            },
            {
                title: "5. Data Security",
                text:
                    "Your data is protected using industry-standard security measures such as HTTPS/TLS encryption, along with appropriate technical and administrative safeguards."
            },
            {
                title: "6. User Rights & Data Deletion",
                text: `You have full control over your personal data.

You may request account deletion by emailing “Account Deletion Request” to destek@gynoclub.com.tr.

Except for legally required records, all data will be permanently deleted within 30 days.`
            },
            {
                title: "7. Contact",
                text: `Company: Gyno Expertise Health Investments Inc.

Address:
Ataköy 7-8-9-10 District, Çobançeşme E-5 Side Road
A-B Block No:18/1, Door No:131
Bakırköy / Istanbul, Turkey

Email:
destek@gynoclub.com.tr
info@gynoclub.com.tr`
            }
        ]
    }
}

export default function Page() {
    const [lang, setLang] = useState<"tr" | "en">("tr")
    const t = content[lang]

    return (
        <main className="w-full min-h-screen bg-[#FAFAFA]">
            <Navbar />

            <section className="relative pt-36 pb-24 overflow-hidden">
                <div className="absolute inset-0">
                    <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-purple-400/20 rounded-full blur-[120px]" />
                    <div className="absolute bottom-[-20%] right-[-10%] w-96 h-96 bg-pink-400/20 rounded-full blur-[120px]" />
                </div>

                <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
                    <div className="flex justify-center mb-6 gap-2">
                        <button
                            onClick={() => setLang("tr")}
                            className={`px-4 py-1 rounded-full text-sm ${lang === "tr" ? "bg-black text-white" : "bg-white text-gray-600"}`}
                        >
                            TR
                        </button>
                        <button
                            onClick={() => setLang("en")}
                            className={`px-4 py-1 rounded-full text-sm ${lang === "en" ? "bg-black text-white" : "bg-white text-gray-600"}`}
                        >
                            EN
                        </button>
                    </div>

                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-4xl md:text-6xl font-extrabold text-gray-900"
                    >
                        {t.titleTop}
                        <span className="block text-transparent bg-clip-text bg-linear-to-r from-[#6320EE] to-[#DA38E2]">
                            {t.titleBottom}
                        </span>
                    </motion.h1>

                    <p className="mt-4 text-sm text-gray-500">{t.lastUpdate}</p>

                    <motion.p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
                        {t.intro}
                    </motion.p>
                    <motion.p className="mt-4 text-gray-600 max-w-2xl mx-auto">
                        {t.accept}
                    </motion.p>
                </div>
            </section>

            <section className="relative z-10 max-w-4xl mx-auto px-6 pb-32">
                <motion.div className="bg-white/80 backdrop-blur-xl rounded-3xl border border-white/40 shadow-[0_20px_50px_rgba(0,0,0,0.08)] p-8 md:p-12 space-y-10">
                    <div className="space-y-8 text-gray-700 leading-relaxed text-sm md:text-base whitespace-pre-line">
                        {t.sections.map((s, i) => (
                            <section key={i}>
                                <h2 className="text-lg font-bold text-gray-900 mb-2">
                                    {s.title}
                                </h2>
                                <p>{s.text}</p>
                            </section>
                        ))}
                    </div>

                    <p className="text-center text-xs text-gray-500 pt-10">
                        © {new Date().getFullYear()} Gyno Club – All rights reserved.
                    </p>
                </motion.div>
            </section>
        </main>
    )
}
